import React, { FC } from 'react';
import Container from '../Container';

const Loader: FC = () => {
  return (
    <Container>
      <div>Loading...</div>
    </Container>
  );
};

export default Loader;
